import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';
import { emphasizedTextFragment } from '../EmphasizedText';
import { fragments as imageFragments } from '../Image';
import { snapchatEmbedFragment } from '../SnapchatEmbed';
import { fragments as videoFragments } from '../Video';

export const cardStackBlockFragment = gql`
  fragment CardStackBlockAll on CardStackBlock {
    ...ContentfulSysId
    eyebrow
    title {
      json
      links {
        entries {
          inline {
            ...ContentfulSysId
            ... on EmphasizedText {
              ...EmphasizedTextAll
            }
          }
        }
      }
    }
    text
    cardsCollection(limit: 4) {
      items {
        ...ContentfulSysId
        title
        body {
          json
        }
        media {
          ...ContentfulSysId
          ... on Video {
            ...VideoAll
          }
          ... on Image {
            ...ImageAll
          }
          ... on SnapchatEmbed {
            ...SnapchatEmbedAll
          }
        }
        url
      }
    }
    anchor
    backgroundColor
    cardMediaAspectRatio
    fullHeight
    textAlignmentDesktop
    textAlignmentMobile
  }
  ${contentfulSysIdFragment}
  ${emphasizedTextFragment}
  ${imageFragments.all}
  ${snapchatEmbedFragment}
  ${videoFragments.all}
`;
